import { GovFormWeb } from '@gov-design-system-ce/react-form';
import {
	useRezaChangeForm,
	type UseRezaChangeOptionsResult,
} from '@gov-nx/core/hooks';
import type { RezaOpravneniDto } from '@gov-nx/api';
import { RezaChangeFormView } from './RezaChangeFormView';

interface RezaChangeFormSectionProps {
	optionsData: UseRezaChangeOptionsResult;
	activeSwitcherReza?: RezaOpravneniDto | null;
	setActiveSwitcherReza: (activeSwitcherReza: RezaOpravneniDto | null) => void;
	formId?: string;
	autoSubmitOnChange?: boolean;
	onAfterSubmit?: () => void;
}

export const RezaChangeFormSection = ({
	optionsData,
	activeSwitcherReza,
	setActiveSwitcherReza,
	formId,
	autoSubmitOnChange,
	onAfterSubmit,
}: RezaChangeFormSectionProps) => {
	const {
		rezaList,
		options,
		singleOptionAsText,
		isRepresentationAllowed,
		hasRepresentationOptions,
	} = optionsData;

	const { form, onSubmit, role, strings } = useRezaChangeForm({
		setActiveSwitcherReza,
		activeSwitcherReza,
		onAfterSubmit,
		autoSubmitOnChange,
		rezaList,
		options,
		singleOptionAsText,
		isRepresentationAllowed,
	});

	return (
		<GovFormWeb
			id={formId}
			onSubmit={onSubmit}
			formDefinition={form}>
			<RezaChangeFormView
				form={form}
				role={role}
				isEligibleListLoading={false}
				isRepresentationAllowed={isRepresentationAllowed}
				hasRepresentationOptions={hasRepresentationOptions}
				singleOptionAsText={singleOptionAsText}
				strings={strings}
			/>
		</GovFormWeb>
	);
};
